import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaSituacaoFinanceira = (): TabelaColuna => ({
  Chave: 'statusFinanceiro',
  Texto: 'Situação Financeira',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => <>{linha.statusFinanceiro}</>
})
